import React from "react";
import { ExperimentProvider } from "../../hooks/useExperiment.js";
import ThemeProvider from "../ThemeProvider/index.js";
import useGlobalRTL from "./hooks/useGlobalRTL.js";
import useGlobalKeyboardMode from "./hooks/useGlobalKeyboardMode.js";
import BUIContext from "./BUIProvider.context.js";
import "@bookingcom/bui-core/css/BUIProvider.css";
import "@bookingcom/bui-core/css/Mixin.module.css";
var providerCount = 0;
var BUIProvider = function (props) {
    var children = props.children, defaultRTL = props.defaultRTL, _a = props.defaultViewportSize, defaultViewportSize = _a === void 0 ? "small" : _a, _b = props.defaultThemeMode, defaultThemeMode = _b === void 0 ? "light" : _b, _c = props.experiments, experiments = _c === void 0 ? {} : _c, theme = props.theme, passedThemeMode = props.themeMode, id = props.id;
    var _d = useGlobalRTL(defaultRTL), rtl = _d[0], setRTL = _d[1];
    var _e = React.useState(defaultThemeMode), themeMode = _e[0], setThemeMode = _e[1];
    var idRef = React.useRef(0);
    // Temporary solution to make id generation unique across multiple BUI providers
    // To be removed once we migrate to React 18 and start using a new hook provided by React
    // https://github.com/facebook/react/pull/22644
    var count = React.useMemo(function () {
        var prefix = providerCount;
        providerCount++;
        return prefix;
    }, []);
    var value = React.useMemo(function () { return ({
        rtl: rtl,
        setRTL: setRTL,
        defaultViewportSize: defaultViewportSize,
        themeMode: passedThemeMode || themeMode,
        setThemeMode: setThemeMode,
        idRef: idRef,
        providerCount: count,
        providerId: id,
        invertThemeMode: function () {
            setThemeMode(themeMode === "light" ? "dark" : "light");
        },
    }); }, [
        rtl,
        setRTL,
        defaultViewportSize,
        themeMode,
        passedThemeMode,
        setThemeMode,
        idRef,
        count,
        id,
    ]);
    useGlobalKeyboardMode();
    return (React.createElement(ExperimentProvider, { value: experiments },
        React.createElement(BUIContext.Provider, { value: value }, theme ? (React.createElement(ThemeProvider, { theme: theme }, children)) : (children))));
};
export default BUIProvider;
